import { ActionFooter, BodyText } from '@cint/wonderment';
import { useMemo } from 'react';
import { FormState } from 'react-hook-form';

import { flattenDirty } from '@/utils/flattenDirty';

export interface FormChangeTrackerProps<FormValues = any> {
  formState: FormState<FormValues>;
  onSave: () => void;
  onDiscard: () => void;
  isSaving?: boolean;
  extraDirtyCount?: number;
  isHidden?: boolean;
  isSaveDisabled?: boolean;
}

export const FormChangeTracker = <FormValues,>({
  formState,
  onSave,
  onDiscard,
  isSaving,
  extraDirtyCount,
  isHidden = false,
  isSaveDisabled = false,
}: FormChangeTrackerProps<FormValues>) => {
  const { dirtyFields } = formState;
  const changeCount = useMemo(() => {
    const formDirtyCount = flattenDirty(dirtyFields).length;
    return formDirtyCount + (extraDirtyCount ?? 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(dirtyFields), extraDirtyCount]);
  if (changeCount === 0) return null;
  return (
    <>
      {!isHidden && (
        <ActionFooter
          isStickyFooter={true}
          additionalContent={
            <BodyText>
              <b>{changeCount}</b> change{changeCount > 1 ? 's' : ''} made
            </BodyText>
          }
          primaryButtonProps={{
            text: 'Save',
            onClick: onSave,
            isDisabled: isSaving || isSaveDisabled,
          }}
          secondaryButtonProps={{
            text: 'Discard changes',
            onClick: onDiscard,
          }}
        />
      )}
    </>
  );
};
